import { DtoFileExtension } from './dto';

/**
 * 프로필 이미지 업로드 전용 allowlist.
 * 전체 DtoFileExtension(video/audio/font 포함)을 그대로 쓰지 않고,
 * 프로필 이미지에는 이미지 타입만 허용한다.
 */
export const PROFILE_IMAGE_MIME_TYPES = [
  'image/jpeg',
  // 일부 브라우저/OS 가 JPEG 를 image/jpg 로 보고함 — 유효한 JPEG 이므로 허용
  'image/jpg',
  'image/png',
  'image/gif',
  'image/webp',
] as const;

export const PROFILE_IMAGE_EXTENSIONS = [
  'jpg',
  'jpeg',
  'png',
  'gif',
  'webp',
] as const;

export type ProfileImageExtension = (typeof PROFILE_IMAGE_EXTENSIONS)[number];

/** 확장자 → DtoFileExtension (이미지 전용 부분집합) */
export const PROFILE_IMAGE_EXTENSION_TO_DTO: Record<
  ProfileImageExtension,
  (typeof DtoFileExtension)[keyof typeof DtoFileExtension]
> = {
  jpg: DtoFileExtension.jpg,
  jpeg: DtoFileExtension.jpeg,
  png: DtoFileExtension.png,
  gif: DtoFileExtension.gif,
  webp: DtoFileExtension.webp,
};

/** `<input accept>` 힌트 문자열 (실제 검증은 아래 함수들이 수행) */
export const PROFILE_IMAGE_ACCEPT = PROFILE_IMAGE_MIME_TYPES.join(',');

export const isAllowedProfileImageMime = (mime: string): boolean =>
  (PROFILE_IMAGE_MIME_TYPES as readonly string[]).includes(mime.toLowerCase());

/** 파일명 확장자가 프로필 이미지 허용 목록에 있으면 반환, 아니면 null */
export const getProfileImageExtension = (
  fileName: string,
): ProfileImageExtension | null => {
  const ext = fileName.split('.').pop()?.toLowerCase() ?? '';
  return (PROFILE_IMAGE_EXTENSIONS as readonly string[]).includes(ext)
    ? (ext as ProfileImageExtension)
    : null;
};
